export const LANDINGPAGE_READY = 'LANDINGPAGE_READY';
export const SPINNER_STATE = 'SPINNER_STATE';
export const CHANGE_MODAL = 'CHANGE_MODAL';
export const CHANGE_LANDINGPAGEPOSITION = 'CHANGE_LANDINGPAGEPOSITION';
export const CHANGE_LANDINGPAGEELEMENT = 'CHANGE_LANDINGPAGEELEMENT';
export const CHANGE_SIDEDRAWER = 'CHANGE_SIDEDRAWER';
export const CHANGE_PATH = 'CHANGE_PATH';

export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const RESET_ERROR_STATE = 'RESET_ERROR_STATE';

export const GET_PROFILE_START = 'GET_PROFILE_START';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAIL = 'GET_PROFILE_FAIL';
export const SET_PROFILE_RESULTS = 'SET_PROFILE_RESULTS';
export const SET_PROFILE_AVATAR = 'SET_PROFILE_AVATAR';
export const DELETE_PROFILE_AVATAR = 'DELETE_PROFILE_AVATAR';
export const DELETE_PROFILE = 'DELETE_PROFILE';
export const SET_LOGOUT_WARNING = 'SET_LOGOUT_WARNING';
export const CAN_PLAY = 'CAN_PLAY';
export const CAN_PLAY_LOADING_STATE = 'CAN_PLAY_LOADING_STATE';

export const QUIZ_CHANGESTAGE = 'QUIZ_CHANGESTAGE';
export const QUIZ_INIT = 'QUIZ_INIT';
export const QUIZ_SETQUESTIONS = 'QUIZ_SETQUESTIONS';
export const QUIZ_ANSWER = 'QUIZ_ANSWER';
export const QUIZ_ENDQUIZ = 'QUIZ_ENDQUIZ';
export const QUIZ_STARTPOSTRESULT = 'QUIZ_STARTPOSTRESULT';
export const QUIZ_SUCCESSPOSTRESULT = 'QUIZ_SUCCESSPOSTRESULT';
export const QUIZ_FAILPOSTRESULT = 'QUIZ_FAILPOSTRESULT';
export const QUIZ_SETERRORSTATE = 'QUIZ_SETERRORSTATE';
export const QUIZ_RESETERRORSTATE = 'QUIZ_RESETERRORSTATE';
export const QUIZ_STARTLOADING = 'QUIZ_STARTLOADING';
export const QUIZ_STOPLOADING = 'QUIZ_STOPLOADING';
export const QUIZ_RESET = 'QUIZ_RESET';

export const GET_RESULTS_BY_DAY = 'GET_RESULTS_BY_DAY';
export const GET_RESULTS_BY_WEEK = 'GET_RESULTS_BY_WEEK';
export const SET_RESULTS_BY_DAY = 'SET_RESULTS_BY_DAY';
export const SET_RESULTS_BY_WEEK = 'SET_RESULTS_BY_WEEK';

export const GET_WINNERS_BY_DAY = 'GET_WINNERS_BY_DAY';
export const GET_WINNERS_BY_WEEK = 'GET_WINNERS_BY_WEEK';
export const GET_MAIN_WINNER = 'GET_MAIN_WINNER';


// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js